module.exports = __webpack_public_path__ + "assets/img/title-88633ae9.png";